export const URL_CHAT_IMAGES =
    'https://www.myfreecams.com/php/user_chat_images.php?format=json'
export const URL_CONTACT_SUPPORT =
    'https://wiki.myfreecams.com/wiki/Contact_Support#Contact_support'
export const URL_MFC_SHARE = 'https://share.myfreecams.com'
export const URL_MFC_SHARE_IFRAMES = `${URL_MFC_SHARE}/iframes/`
export const URL_MFC_SHARE_TIP_MENUS = `${URL_MFC_SHARE_IFRAMES}tipmenus/`
export const URL_MFC_WIKI = 'https://wiki.myfreecams.com/wiki/Main_Page'
export const URL_PASSWORD_RESET =
    'https://www.myfreecams.com/php/account.php?request=password&mode=app&load=app&style=app'
